import { ReactElement, Suspense, lazy } from 'react';
import { Navigate as Redirect, Route, Routes } from 'react-router-dom';
import { SaleProvider } from './context';
import { SalePath } from './routes';

const NewSale = lazy(() => import('./pages/NewSale/NewSale'));
const SaleList = lazy(() => import('./pages/SaleList/SaleList'));
const CreditSales = lazy(() => import('./pages/CreditSales/CreditSales'));
const CreditsalesPayments = lazy(() => import('./pages/CreditsalesPayments/CreditsalesPayments'));

export const SaleRoutes: React.FC = (): ReactElement => {
  return (
    <Suspense>
      <Routes>
        <Route path={SalePath.NewSale} element={<NewSale />} />
        <Route path={SalePath.SaleList} element={<SaleList />} />
        <Route path={SalePath.CreditSale} element={<CreditSales />} />
        <Route path={SalePath.CreditSalePayment} element={<CreditsalesPayments />} />
        <Route path="*" element={<Redirect to={SalePath.SaleList} replace />} />
      </Routes>
    </Suspense>
  );
};

export const SaleRouter: React.FC = () => (
  <SaleProvider>
    <SaleRoutes />
  </SaleProvider>
);
